<template>
  <div class="quoted-template">
    <div class="template-head">
      <div class="template-input">
        <div class="quoted-template-query">
          <el-tooltip v-if="isMaintainT" class="item" effect="dark" :content="templateForm.templateName" placement="top-start">
            <el-input v-model="templateForm.templateName" class="tem-input">
              <el-button slot="append" icon="el-icon-search" @click="haveSafeguard"></el-button>
            </el-input>
          </el-tooltip>
          <mInput v-else :params="chargTemplate" @getAdvanceValue="getAdvanceValue" :disabled="false" :mValue="templateForm.templateName"
            :templateCode="templateForm.templateCode" :bidNo="bidData.bidNo"></mInput>
            <div class="quoted-template-query-item">
              <span class="quoted-template-query-label">是否防倒挂：</span>
              <MSelect
              class="quoted-template-query-select"
              :optionNum="'SRM_YES_NO'"
              :disabled="true"
              placeholder=""
              :value="templateForm.priceBarb"
              :filterable="true">
            </MSelect>
            </div>
    
          </div>

      <!-- <p class="tips-text">计费规则：{{templateForm.templateDesc}}</p> -->
       </div>
            <div class="templateFile-box" v-if="files.fileName">
              模板说明：
               <el-tooltip effect="dark" :content="files.fileName" placement="bottom">
              <div class="templateFile-left" @click="preview">{{files.fileName}}</div>
              </el-tooltip>
               <div class="templateFile-right">
                 <span class="templateFile-text" @click="downFile">下载</span>
               </div>
            </div>
    </div>
    <div class="template-btn">
      <div class="btn-left">
        <span class="btn-span" v-has="'02010007'"><el-button class="bigData-btn-quotedTemp-save" type="primary" @click="saveList" :loading="loadSave" :disabled="delBtn?false:true">
          保存</el-button></span>
        <span class="btn-span" v-has="'02010008'"><el-button class="bigData-btn-quotedTemp-delete" type="primary" @click="deleteTemplate" :loading="loadDelete" :disabled="delBtn?false:true">
          删除</el-button></span>
        <span class="btn-span" v-has="'02010009'"><el-button class="bigData-btn-quotedTemp-lbjsp" type="primary" @click="markThePrice" :disabled="isExamine?false:true">拦标价审批</el-button></span>
        <span class="btn-span" v-has="'02010010'"><el-button class="bigData-btn-quotedTemp-gblbj" type="primary" @click="publishPrice"  :loading="loadPrice" :disabled="isPublish?false:true">
          公布拦标价</el-button></span>
        <span class="btn-span" v-has="'02010011'"><el-button class="bigData-btn-quotedTemp-privilege" type="primary" :disabled="!privilegeButton" @click="privilegeClick" :loading="loadSave">
          特权修改</el-button></span>
      </div>
      <div v-if="!isMoreRuleTemplate" class="btn-right">
       <el-dropdown @command="handleCommand" v-if="exportBtn" v-has="'02010012'" trigger="click">
            <span class="el-dropdown-link">
              导出<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="quoted-tpl-el-dropdown-menu">
              <el-dropdown-item :command="'TEMMPLATE'" :disabled="etLoading"><el-button class="bigData-btn-quotedTemp-exTemp" type="text" :loading="etLoading">导出模板</el-button></el-dropdown-item>
              <el-dropdown-item :command="'DETAIL'" :disabled="edLoading"><el-button class="bigData-btn-quotedTemp-exDetail" type="text" :loading="edLoading">导出明细</el-button></el-dropdown-item>
              <el-dropdown-item :command="'LINE'" :disabled="elLoading"><el-button class="bigData-btn-quotedTemp-exRoute" type="text" :loading="elLoading">导出线路</el-button></el-dropdown-item>
              <el-dropdown-item :command="'ADMINISTRATIVE'" :disabled="eaLoading"><el-button class="bigData-btn-quotedTemp-exPlan" type="text" :loading="eaLoading">
                导出行政规划</el-button></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <span v-else class="el-dropdown-link" @click="exportTip" v-has="'02010012'"><i class="el-icon-upload2"></i>导出 </span>
        <m-import resourceId='02010013' :disabled="importQuotationBtn?false:true" :num="'quoteTemp'" :params="uploadParams"
        :uploadUrl="uploadUrl" @import-callback="success" :class="importQuotationBtn?'':'export-template'">
          <span class="bigData-btn-quotedTemp-imPriceTemp" slot="button-name">导入报价模板</span>
        </m-import>
        <m-import resourceId='02010014' :disabled="isPrice?false:true" :num="'2'" :params="uploadParams" :uploadUrl="uploadPriceUrl" @import-callback="success">
          <span class="bigData-btn-quotedTemp-imLbj" slot="button-name">导入拦标价</span>
        </m-import>
      </div>
      <more-rule-buttons v-else :exportBtn="exportBtn" :importQuotationBtn="importQuotationBtn" :uploadParams="uploadParams"
          :isPrice="isPrice" :bidData="bidData" :dictData="dictData" :templateCode="templateForm.templateCode" @success="success" />
    </div>
    <div class="template-table" v-if="!isMoreRuleTemplate">
      <vbt-table isBigData v-loading="loading" class="tb-edit" element-loading-spinner="el-icon-loading" element-loading-text="列表加载中" ref="topicTable"
      :data="tableData" height="550" :row-class-name="tableRowClassName" style="width: 100%;" border highlight-current-row @expand-change="expandRow" @current-change="handleCurrentChange"
        @row-dblclick.self="dblClick($event)" @row-click="handClick" :data-size="tableData.length">
        <vbt-table-column :label="'序号'" prop="rowNumber"  width="50" align="center"></vbt-table-column>
        <vbt-table-column width="40">
          <template slot="header" slot-scope="scope">
              <el-checkbox @change="selectAll(scope,$event)" v-model="selectAllType"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-if="!scope.row.quoteCodeParent" @change="selectOne(scope.row,$event)" v-model="scope.row.isSelect"></el-checkbox>
            <el-checkbox v-else @change="selectTwo(scope.row,$event)" v-model="scope.row.isSelect"></el-checkbox>
          </template>
        </vbt-table-column>
        <!-- -----自定义列---- -->
        <template v-if="customList&&customList.length!=0">
          <template v-for="(item,index) in customList">
            <vbt-table-column :key="item.key+item.fieldName"  :label="item.fieldName" width="120" :show-overflow-tooltip="item.fieldName === '标段'">
              <template slot-scope="scope">
                <template v-if="index===0&&!scope.row.quoteCodeParent">
                  <span class="caret" @click.stop="showDetail(scope.row)" :key="item.key">
                    <i class="el-icon-caret-right" v-if="!scope.row.showSubTable"></i>
                    <i class="el-icon-caret-bottom" v-if="scope.row.showSubTable"></i>
                  </span>
                </template>
                <template v-if="item.fieldName==='老供应商编码'">
                  <postInput class="post-input" v-if="scope.row.edit" :params="formerSupplierData"
                  @getAdvanceValue="getformerSupplier($event,scope.row)" :mValue="scope.row.formerSupplierCode"></postInput>
                  <span v-else>{{ scope.row.formerSupplierCode}}</span>
                </template>
                <template v-if="item.fieldName!=='老供应商编码'">
                    <el-input v-if="scope.row.edit" v-model="scope.row[item.prop]"></el-input>
                    <span v-else>{{ scope.row[item.prop]}}</span>
                </template>
              </template>
            </vbt-table-column>
          </template>
        </template>
      </vbt-table>
    </div>
    <more-rule-tables v-else ref="moreRuleTables" :bidData="bidData" :formerSupplierData="formerSupplierData" :isPrivilege="isPrivilege" :changeSeq="changeSeq" :changeReson="changeReson"
      @saveSuccess="handleRefresh" @deleteSuccess="handleRefresh" />
    <privilegeDialog v-if="showPrivilegeDialog" :showPrivilegeDialog.sync="showPrivilegeDialog" @privilegeConfirm="privilegeConfirm"></privilegeDialog>
  </div>
</template>
<script>
import quotedTemplate from './quotedTemplateCode/quotedTemplate.js';
export default quotedTemplate;
</script>
<style lang="less">
@import url("./quotedTemplateCode/quotedTemplate.css");
</style>
